import React from "react";
import TenantHandler from "../handlers/tenant";
import { useQuery } from "@tanstack/react-query";
import { isSuperAdmin } from "../utils/helpers/helper";

const useAdminMonthlyHighCutOff = (authUser) => {
	const tenantHandler = new TenantHandler();

	const { data, isLoading } = useQuery({
		queryKey: ["monthly_high_cutoff"],
		queryFn: () => tenantHandler.getAdminMonthlyHighCutOff(),
		select: (data) => data?.data?.monthly_high_cu,
		enabled: isSuperAdmin(authUser?.role),
		gcTime: 0,
	});

	return { data, isLoading };
};

export default useAdminMonthlyHighCutOff;
